
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";
import Endodoncia from "../pacientes/fichas/Endodoncia.vue"
import Periodoncia from "../pacientes/fichas/Periodoncia.vue"
import Ortodoncia from "../pacientes/fichas/Ortodoncia.vue"

@Component({
	name: "Ficha",
	components: {Endodoncia, Periodoncia, Ortodoncia}
})

export default class Ficha extends Vue {
	@Prop() paciente_id!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	fichas = []
	citas = []
	cita = null
	id = 0
	swEditar = false
	ficha = null
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	mounted() {
		this.id = Number(this.$route.query.id)
		this.getFichas()
		this.getCitas()
	}
	async getFichas() {
		
		await http.get(`fichas`, {params: {paciente_id: this.paciente_id}}).subscribe({
			next: (response:AxiosResponse) => {
				this.consultorioStore.citas = response.data
				this.fichas = response.data;
			},
		})
	}
	async getCitas() {
		
		await http.get(`get-citas-ficha`, {params: {paciente_id: this.paciente_id}}).subscribe({
			next: (response:AxiosResponse) => {
				this.consultorioStore.citas = response.data
				this.citas = response.data;
			},
		})
	}
	editar(ficha:any){
		this.swEditar = true;
		this.cita = ficha.cita;
		this.ficha = ficha
	}
	async imprimirFicha() {
		await http.get(`imprimir-ficha/${this.ficha.id}`).subscribe(response =>{
					window.open(
						`${process.env.VUE_APP_URL}imprimir-ficha/${this.ficha.id}`, "_blank");
						//import.meta.env.VITE_APP_URL +`imprimir-solicitud/${id}`, "_blank");

		})
	}
	
}

